import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

// import { PhnxForminput } from './Forminput'
// import { ForminputProps } from './Forminput'

interface ForminputBlokProps {
  blok: {
    // title: ForminputProps['title']
  } & SbBlokData
}

const Forminput: FC<ForminputBlokProps> = ({ blok }) => {
  return <div {...storyblokEditable(blok)}>{/* <PhnxForminput title={blok.title} /> */}</div>
}

export default Forminput
